import { type ComponentPropsWithoutRef } from 'react';
import { CheckSmallIcon } from '@/icons';
import { SelectContent } from './SelectContent';
import { SelectItem } from './SelectItem';
import { type SelectOption } from './type';
type SingleSelectContentProps<T extends string = string> = Omit<ComponentPropsWithoutRef<typeof SelectContent>, 'onSelect'> & {
  close: () => void;
  onSelect?: (value: T) => void;
  options: SelectOption<T>[];
  value?: T | null;
  className?: string;
  showScrollbar?: boolean;
  showSelectedIcon?: boolean;
};
export const SingleSelectContent = <T extends string = string,>({
  close,
  onSelect,
  options,
  value,
  className,
  showScrollbar,
  showSelectedIcon = true,
  ...props
}: SingleSelectContentProps<T>) => {
  return <SelectContent {...props} onPointerDownOutside={close} className={className} showScrollbar={showScrollbar} onCloseAutoFocus={e => e.preventDefault()} data-sentry-element="SelectContent" data-sentry-component="SingleSelectContent" data-sentry-source-file="SingleSelectContent.tsx">
      {options.map(option => <SelectItem key={option.value} value={option.value} checked={value === option.value} label={option.label} invalid={option.invalid} disabled={option.disabled} rightSlot={showSelectedIcon && value === option.value ? <CheckSmallIcon size="xs" /> : undefined} onClick={() => {
      onSelect?.(option.value);
    }} />)}
    </SelectContent>;
};